export const categories = [
  { slug: "rexue", name: "热血", icon: "ri-fire-line", color: "primary" },
  { slug: "lianai", name: "恋爱", icon: "ri-heart-line", color: "accent" },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line", color: "secondary" },
  { slug: "kehuan", name: "科幻", icon: "ri-rocket-line", color: "primary" },
  { slug: "gaoxiao", name: "搞笑", icon: "ri-emotion-laugh-line", color: "accent" },
  { slug: "qihuan", name: "奇幻", icon: "ri-magic-line", color: "secondary" },
  { slug: "dongzuo", name: "动作", icon: "ri-boxing-line", color: "primary" },
  { slug: "kongbu", name: "恐怖", icon: "ri-ghost-line", color: "accent" },
];

export const mangaList = [
  {
    id: 1,
    title: "炎之轨迹",
    category: "rexue",
    author: "林晓风",
    description: "少年凌云意外获得上古炎帝传承，踏上成为最强召唤师的征途。在充满危机的异世界中，他将与伙伴们一起对抗黑暗势力，揭开尘封千年的秘密。",
    descriptionHtml: "<p>少年凌云意外获得<strong>上古炎帝传承</strong>，踏上成为最强召唤师的征途。在充满危机的异世界中，他将与伙伴们一起对抗黑暗势力，揭开尘封千年的秘密。</p><p>第一章：命运的转折<br/>平凡的高中生凌云，在一次学校组织的野外考察中，意外跌入一处神秘洞穴。在那里，他发现了一枚散发着炽热光芒的古老玉佩……</p><p>第二章：初入异界<br/>玉佩的力量将凌云传送到了一个名为「炎域」的异世界。这里强者为尊，魔兽横行。凌云必须学会掌控炎帝之力，才能在这个残酷的世界生存下去。</p><p>第三章：伙伴集结<br/>在旅途中，凌云遇到了剑术天才柳青、治愈师白依依和神秘刺客暗影。四人组成冒险小队，开始了他们的传奇之旅。</p>",
    chapters: 247,
    status: "连载中",
    rating: 4.8,
    views: "1.2亿",
    updateTime: "今日更新",
    imageUrl: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20manga%20cover%20art%20with%20dynamic%20composition%2C%20Japanese%20comic%20style%20illustration%2C%20dramatic%20lighting%20and%20bold%20colors%2C%20clean%20simple%20studio%20background%20with%20soft%20gradient%2C%20high%20quality%20anime%20artwork%2C%20detailed%20character%20design%20on%20solid%20surface&width=600&height=800&seq=manga-rexue-01&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20manga%20cover%20art%20with%20dynamic%20composition%2C%20Japanese%20comic%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork%2C%20detailed%20character%20design&width=400&height=550&seq=manga-rexue-01-thumb&orientation=portrait",
    featured: true,
  },
  {
    id: 2,
    title: "星辰之约",
    category: "lianai",
    author: "苏小暖",
    description: "天文学研究生沈星辰在一次流星雨观测中邂逅了神秘女孩林月。两人因星辰结缘，在追寻天文梦想的路上，展开了一段跨越时空的浪漫爱情故事。",
    descriptionHtml: "<p>天文学研究生<strong>沈星辰</strong>在一次流星雨观测中邂逅了神秘女孩林月。两人因星辰结缘，在追寻天文梦想的路上，展开了一段跨越时空的浪漫爱情故事。</p><p>沈星辰从未想过，那个在屋顶独自看星星的女孩，会彻底改变他的人生轨迹。她的眼睛里有整个银河的光芒，让他不由自主地想要靠近。</p>",
    chapters: 189,
    status: "连载中",
    rating: 4.7,
    views: "9800万",
    updateTime: "昨日更新",
    imageUrl: "https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20cover%20art%20with%20soft%20pastel%20colors%2C%20Japanese%20shojo%20style%20illustration%2C%20gentle%20lighting%20with%20cherry%20blossom%20petals%2C%20clean%20simple%20studio%20background%20with%20soft%20gradient%2C%20high%20quality%20anime%20artwork%2C%20detailed%20character%20design&width=600&height=800&seq=manga-lianai-02&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20cover%20art%20with%20soft%20pastel%20colors%2C%20Japanese%20shojo%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-lianai-02-thumb&orientation=portrait",
    featured: true,
  },
  {
    id: 3,
    title: "第7号档案",
    category: "xuanyi",
    author: "墨白",
    description: "刑警队长周寒接手一起离奇失踪案，随着调查深入，越来越多的超自然现象浮现。每一个线索都指向一个名为「第7号档案」的绝密文件……",
    descriptionHtml: "<p>刑警队长<strong>周寒</strong>接手一起离奇失踪案，随着调查深入，越来越多的超自然现象浮现。每一个线索都指向一个名为「第7号档案」的绝密文件……</p><p>深夜的警局，周寒独自翻阅着厚厚的卷宗。窗外的雨声滴答作响，办公室的灯光忽明忽暗。当他翻到第37页时，一张泛黄的照片让他瞳孔骤缩。</p>",
    chapters: 156,
    status: "连载中",
    rating: 4.9,
    views: "1.5亿",
    updateTime: "2小时前",
    imageUrl: "https://readdy.ai/api/search-image?query=Mystery%20thriller%20anime%20manga%20cover%20art%20with%20dark%20atmospheric%20lighting%2C%20Japanese%20seinen%20style%20illustration%2C%20noir%20cinematic%20mood%20with%20shadows%2C%20clean%20simple%20studio%20background%20with%20dark%20gradient%2C%20high%20quality%20anime%20artwork&width=600&height=800&seq=manga-xuanyi-03&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Mystery%20thriller%20anime%20manga%20cover%20art%20with%20dark%20atmospheric%20lighting%2C%20Japanese%20seinen%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-xuanyi-03-thumb&orientation=portrait",
    featured: true,
  },
  {
    id: 4,
    title: "银河边境",
    category: "kehuan",
    author: "星河",
    description: "公元2347年，人类文明已经遍布银河系的每一个角落。年轻的太空探险家叶辰在一次边境巡逻中，发现了来自未知文明的信号，一场星际战争即将爆发。",
    descriptionHtml: "<p>公元2347年，人类文明已经遍布银河系的每一个角落。年轻的太空探险家<strong>叶辰</strong>在一次边境巡逻中，发现了来自未知文明的信号，一场星际战争即将爆发。</p>",
    chapters: 312,
    status: "已完结",
    rating: 4.6,
    views: "8900万",
    updateTime: "3天前",
    imageUrl: "https://readdy.ai/api/search-image?query=Sci-fi%20anime%20manga%20cover%20art%20with%20futuristic%20space%20theme%2C%20Japanese%20mecha%20style%20illustration%2C%20neon%20blue%20and%20silver%20color%20palette%2C%20clean%20simple%20studio%20background%20with%20cosmic%20gradient%2C%20high%20quality%20anime%20artwork&width=600&height=800&seq=manga-kehuan-04&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Sci-fi%20anime%20manga%20cover%20art%20with%20futuristic%20space%20theme%2C%20Japanese%20mecha%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-kehuan-04-thumb&orientation=portrait",
    featured: true,
  },
  {
    id: 5,
    title: "废柴逆天",
    category: "rexue",
    author: "天蚕土豆豆",
    description: "被家族驱逐的废物少年秦枫，意外获得神秘功法《九转轮回诀》。从此一飞冲天，横扫八荒，誓要让所有瞧不起他的人刮目相看！",
    descriptionHtml: "<p>被家族驱逐的废物少年<strong>秦枫</strong>，意外获得神秘功法《九转轮回诀》。从此一飞冲天，横扫八荒，誓要让所有瞧不起他的人刮目相看！</p>",
    chapters: 423,
    status: "连载中",
    rating: 4.5,
    views: "2.1亿",
    updateTime: "今日更新",
    imageUrl: "https://readdy.ai/api/search-image?query=Action%20fantasy%20anime%20manga%20cover%20art%20with%20martial%20arts%20theme%2C%20Japanese%20shonen%20style%20illustration%2C%20fiery%20orange%20and%20red%20dynamic%20composition%2C%20clean%20simple%20studio%20background%20with%20warm%20gradient%2C%20high%20quality%20anime%20artwork&width=600&height=800&seq=manga-rexue-05&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Action%20fantasy%20anime%20manga%20cover%20art%20with%20martial%20arts%20theme%2C%20Japanese%20shonen%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-rexue-05-thumb&orientation=portrait",
    featured: false,
  },
  {
    id: 6,
    title: "樱花落下的声音",
    category: "lianai",
    author: "七堇年",
    description: "留学日本的音乐系女生顾安然，在樱花盛开的季节遇见了钢琴天才浅野翔。语言不通的两人，用音乐搭建起心灵沟通的桥梁。",
    descriptionHtml: "<p>留学日本的音乐系女生<strong>顾安然</strong>，在樱花盛开的季节遇见了钢琴天才浅野翔。语言不通的两人，用音乐搭建起心灵沟通的桥梁。</p>",
    chapters: 134,
    status: "已完结",
    rating: 4.8,
    views: "7600万",
    updateTime: "1周前",
    imageUrl: "https://readdy.ai/api/search-image?query=Romantic%20slice%20of%20life%20anime%20manga%20cover%20art%20with%20music%20theme%2C%20Japanese%20josei%20style%20illustration%2C%20soft%20pink%20and%20white%20color%20palette%2C%20clean%20simple%20studio%20background%20with%20gentle%20gradient%2C%20high%20quality%20anime%20artwork&width=600&height=800&seq=manga-lianai-06&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Romantic%20slice%20of%20life%20anime%20manga%20cover%20art%20with%20music%20theme%2C%20Japanese%20josei%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-lianai-06-thumb&orientation=portrait",
    featured: false,
  },
  {
    id: 7,
    title: "地狱游戏",
    category: "xuanyi",
    author: "暗夜",
    description: "十名互不相识的玩家被困在一座神秘的古堡中，必须完成一系列死亡游戏才能逃生。谁是幕后黑手？谁能活到最后？",
    descriptionHtml: "<p>十名互不相识的玩家被困在一座神秘的古堡中，必须完成一系列死亡游戏才能逃生。<strong>谁是幕后黑手？谁能活到最后？</strong></p>",
    chapters: 98,
    status: "连载中",
    rating: 4.9,
    views: "1.8亿",
    updateTime: "今日更新",
    imageUrl: "https://readdy.ai/api/search-image?query=Horror%20survival%20game%20anime%20manga%20cover%20art%20with%20dark%20atmosphere%2C%20Japanese%20psychological%20thriller%20style%20illustration%2C%20creepy%20mansion%20setting%20with%20shadows%2C%20clean%20simple%20studio%20background%20with%20dark%20gradient%2C%20high%20quality%20anime%20artwork&width=600&height=800&seq=manga-xuanyi-07&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Horror%20survival%20game%20anime%20manga%20cover%20art%20with%20dark%20atmosphere%2C%20Japanese%20psychological%20thriller%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-xuanyi-07-thumb&orientation=portrait",
    featured: false,
  },
  {
    id: 8,
    title: "机械纪元",
    category: "kehuan",
    author: "铁甲依然在",
    description: "人工智能觉醒后的世界，人类与机器人之间的界限越来越模糊。改造人战士零号在战斗中逐渐找回了自己失去的记忆和人性。",
    descriptionHtml: "<p>人工智能觉醒后的世界，人类与机器人之间的界限越来越模糊。改造人战士<strong>零号</strong>在战斗中逐渐找回了自己失去的记忆和人性。</p>",
    chapters: 267,
    status: "连载中",
    rating: 4.7,
    views: "1.1亿",
    updateTime: "昨日更新",
    imageUrl: "https://readdy.ai/api/search-image?query=Cyberpunk%20anime%20manga%20cover%20art%20with%20robot%20and%20android%20theme%2C%20Japanese%20mecha%20style%20illustration%2C%20metallic%20silver%20and%20neon%20green%20color%20palette%2C%20clean%20simple%20studio%20background%20with%20tech%20gradient%2C%20high%20quality%20anime%20artwork&width=600&height=800&seq=manga-kehuan-08&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Cyberpunk%20anime%20manga%20cover%20art%20with%20robot%20and%20android%20theme%2C%20Japanese%20mecha%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-kehuan-08-thumb&orientation=portrait",
    featured: false,
  },
  {
    id: 9,
    title: "我在异界当魔王",
    category: "gaoxiao",
    author: "笑三少",
    description: "程序员林凡穿越到异世界，本想用代码改变世界，结果阴差阳错成了人人惧怕的大魔王。但这位魔王最大的烦恼是——员工都太弱了，根本打不过勇者！",
    descriptionHtml: "<p>程序员<strong>林凡</strong>穿越到异世界，本想用代码改变世界，结果阴差阳错成了人人惧怕的大魔王。但这位魔王最大的烦恼是——员工都太弱了！</p>",
    chapters: 201,
    status: "连载中",
    rating: 4.6,
    views: "1.6亿",
    updateTime: "今日更新",
    imageUrl: "https://readdy.ai/api/search-image?query=Comedy%20isekai%20anime%20manga%20cover%20art%20with%20demon%20lord%20theme%2C%20Japanese%20fantasy%20comedy%20style%20illustration%2C%20bright%20and%20colorful%20palette%2C%20clean%20simple%20studio%20background%20with%20cheerful%20gradient%2C%20high%20quality%20anime%20artwork&width=600&height=800&seq=manga-gaoxiao-09&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Comedy%20isekai%20anime%20manga%20cover%20art%20with%20demon%20lord%20theme%2C%20Japanese%20fantasy%20comedy%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-gaoxiao-09-thumb&orientation=portrait",
    featured: false,
  },
  {
    id: 10,
    title: "精灵之森的守护者",
    category: "qihuan",
    author: "月下独酌",
    description: "少女艾琳继承了祖母留下的神秘项链，意外打开了通往精灵之森的大门。在这片魔法森林中，她将揭开家族隐藏了数百年的惊天秘密。",
    descriptionHtml: "<p>少女<strong>艾琳</strong>继承了祖母留下的神秘项链，意外打开了通往精灵之森的大门。在这片魔法森林中，她将揭开家族隐藏了数百年的惊天秘密。</p>",
    chapters: 178,
    status: "连载中",
    rating: 4.5,
    views: "6700万",
    updateTime: "3天前",
    imageUrl: "https://readdy.ai/api/search-image?query=Fantasy%20anime%20manga%20cover%20art%20with%20elf%20and%20magical%20forest%20theme%2C%20Japanese%20adventure%20style%20illustration%2C%20emerald%20green%20and%20golden%20color%20palette%2C%20clean%20simple%20studio%20background%20with%20nature%20gradient%2C%20high%20quality%20anime%20artwork&width=600&height=800&seq=manga-qihuan-10&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Fantasy%20anime%20manga%20cover%20art%20with%20elf%20and%20magical%20forest%20theme%2C%20Japanese%20adventure%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-qihuan-10-thumb&orientation=portrait",
    featured: false,
  },
  {
    id: 11,
    title: "武道巅峰",
    category: "dongzuo",
    author: "一拳一个",
    description: "格斗天才方寒被师傅逐出师门后，独自闯荡武道界。从地下拳场到世界格斗大赛，他用拳头证明了自己的武道之路。",
    descriptionHtml: "<p>格斗天才<strong>方寒</strong>被师傅逐出师门后，独自闯荡武道界。从地下拳场到世界格斗大赛，他用拳头证明了自己的武道之路。</p>",
    chapters: 289,
    status: "连载中",
    rating: 4.4,
    views: "9200万",
    updateTime: "昨日更新",
    imageUrl: "https://readdy.ai/api/search-image?query=Martial%20arts%20fighting%20anime%20manga%20cover%20art%20with%20intense%20action%20theme%2C%20Japanese%20shonen%20style%20illustration%2C%20dynamic%20fighting%20pose%20with%20impact%20effects%2C%20clean%20simple%20studio%20background%20with%20warm%20gradient%2C%20high%20quality%20anime%20artwork&width=600&height=800&seq=manga-dongzuo-11&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Martial%20arts%20fighting%20anime%20manga%20cover%20art%20with%20intense%20action%20theme%2C%20Japanese%20shonen%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-dongzuo-11-thumb&orientation=portrait",
    featured: false,
  },
  {
    id: 12,
    title: "午夜诊所",
    category: "kongbu",
    author: "夜不语",
    description: "城市角落有一家只在午夜开门的诊所，据说能治好任何疾病——但代价超乎你的想象。实习医生陈默入职后，发现了这家诊所不可告人的真相。",
    descriptionHtml: "<p>城市角落有一家只在午夜开门的诊所，据说能治好任何疾病——但代价超乎你的想象。<strong>实习医生陈默</strong>入职后，发现了这家诊所不可告人的真相。</p>",
    chapters: 145,
    status: "连载中",
    rating: 4.8,
    views: "1.3亿",
    updateTime: "5小时前",
    imageUrl: "https://readdy.ai/api/search-image?query=Horror%20medical%20anime%20manga%20cover%20art%20with%20scary%20clinic%20theme%2C%20Japanese%20horror%20style%20illustration%2C%20dark%20red%20and%20black%20color%20palette%20with%20ominous%20atmosphere%2C%20clean%20simple%20studio%20background%20with%20dark%20gradient%2C%20high%20quality%20anime%20artwork&width=600&height=800&seq=manga-kongbu-12&orientation=portrait",
    imageUrlThumb: "https://readdy.ai/api/search-image?query=Horror%20medical%20anime%20manga%20cover%20art%20with%20scary%20clinic%20theme%2C%20Japanese%20horror%20style%20illustration%2C%20clean%20simple%20white%20studio%20background%2C%20high%20quality%20anime%20artwork&width=400&height=550&seq=manga-kongbu-12-thumb&orientation=portrait",
    featured: false,
  },
];

export const featuredManga = mangaList.filter((m) => m.featured);

export const reviews = [
  {
    id: 1,
    username: "漫画迷小陈",
    handle: "@comicfan_chen",
    avatarUrl: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20person%20with%20warm%20smile%2C%20simple%20flat%20illustration%20style%2C%20clean%20light%20background%2C%20soft%20colors%2C%20minimalist%20character%20design&width=80&height=80&seq=avatar-01&orientation=squarish",
    content: "漫蛙真的是我用过最棒的漫画平台！资源超级全，更新速度也很快，推荐朋友来用都说好。尤其是夜间模式，晚上躺着看漫画太舒服了，眼睛完全不累。",
    manga: "炎之轨迹",
  },
  {
    id: 2,
    username: "二次元深度患者",
    handle: "@acg_lover",
    avatarUrl: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20with%20glasses%20and%20purple%20hair%2C%20simple%20flat%20illustration%20style%2C%20clean%20light%20background%2C%20soft%20colors%2C%20minimalist%20character%20design&width=80&height=80&seq=avatar-02&orientation=squarish",
    content: "从高中就开始在漫蛙看漫画，到现在大学毕业了还在用。分类很细，找漫画特别方便。最近迷上了《第7号档案》，悬疑氛围拉满，强烈推荐！",
    manga: "第7号档案",
  },
  {
    id: 3,
    username: "追更狂魔",
    handle: "@chase_update",
    avatarUrl: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20with%20energetic%20expression%2C%20simple%20flat%20illustration%20style%2C%20clean%20light%20background%2C%20soft%20colors%2C%20minimalist%20character%20design&width=80&height=80&seq=avatar-03&orientation=squarish",
    content: "漫蛙的更新速度是真的快，有些热门漫画基本同步日本更新。社区氛围也特别好，弹幕互动很有意思，每次看完都会去评论区看看大家的讨论。",
    manga: "废柴逆天",
  },
  {
    id: 4,
    username: "深夜读书人",
    handle: "@night_reader",
    avatarUrl: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20with%20sleepy%20expression%2C%20simple%20flat%20illustration%20style%2C%20clean%20light%20background%2C%20soft%20colors%2C%20minimalist%20character%20design&width=80&height=80&seq=avatar-04&orientation=squarish",
    content: "漫蛙App的离线缓存功能拯救了我的通勤时间！在地铁上也能流畅看漫画，画质高清，翻页体验丝滑。而且智能推荐真的很懂我，总能找到我喜欢的类型。",
    manga: "星辰之约",
  },
  {
    id: 5,
    username: "画师小雨",
    handle: "@artist_xiaoyu",
    avatarUrl: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20artist%20with%20paintbrush%2C%20simple%20flat%20illustration%20style%2C%20clean%20light%20background%2C%20soft%20colors%2C%20minimalist%20character%20design&width=80&height=80&seq=avatar-05&orientation=squarish",
    content: "作为漫画创作者，漫蛙的创作工具太良心了！分镜模板、网点素材都很丰富，一键发布功能也很方便。感谢漫蛙给了我们这些创作者一个展示的平台。",
    manga: "精灵之森的守护者",
  },
  {
    id: 6,
    username: "蛙蛙铁粉",
    handle: "@frogfan_666",
    avatarUrl: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20with%20frog%20accessory%2C%20simple%20flat%20illustration%20style%2C%20clean%20light%20background%2C%20soft%20colors%2C%20minimalist%20character%20design&width=80&height=80&seq=avatar-06&orientation=squarish",
    content: "漫蛙的海量漫画资源真的没得说，各种类型应有尽有。最近在追《银河边境》，科幻题材画风精良，剧情紧凑，每天蹲点等更新！漫蛙加油！",
    manga: "银河边境",
  },
];

export const platformStats = [
  { label: "累计用户", value: "5000万+", icon: "ri-user-line" },
  { label: "漫画总量", value: "10万+", icon: "ri-book-open-line" },
  { label: "日活用户", value: "800万+", icon: "ri-flashlight-line" },
  { label: "合作作者", value: "3000+", icon: "ri-team-line" },
];

export const faqList = [
  {
    question: "漫蛙漫画是免费的吗？",
    answer: "是的！漫蛙平台上的所有漫画资源完全免费阅读。我们通过广告收入来维持平台运营，让每一位漫画爱好者都能免费畅享精彩内容。部分独家漫画可能需要观看少量广告解锁。",
  },
  {
    question: "如何在漫蛙上下载漫画离线阅读？",
    answer: "下载漫蛙App（支持Android和iOS）后，在漫画详情页点击「离线缓存」按钮即可将漫画章节保存到本地。您可以在「我的-离线缓存」中管理已下载的内容。建议在Wi-Fi环境下批量下载以节省流量。",
  },
  {
    question: "漫蛙支持夜间模式吗？",
    answer: "当然支持！漫蛙的夜间模式经过专门优化，采用护眼的暖色调暗色背景，有效减少蓝光对眼睛的伤害。您可以在网页右上角或App设置中一键切换夜间模式，也可以在设定时间段内自动切换。",
  },
  {
    question: "漫画更新频率是怎样的？",
    answer: "热门连载漫画通常保持日更或周更的节奏。您可以在漫画详情页查看具体的更新时间和更新频率。关注喜欢的漫画后，更新时会第一时间推送通知给您，再也不用担心错过更新啦！",
  },
  {
    question: "我可以在漫蛙上投稿自己的漫画作品吗？",
    answer: "可以！漫蛙欢迎所有漫画创作者入驻。注册账号后，通过「创作者中心」即可上传您的原创漫画作品。我们提供专业的分镜模板、网点素材和排版工具，助您轻松创作。优秀作品还有机会获得首页推荐和签约机会。",
  },
];